module.exports = __webpack_public_path__ + "static/media/Eid_Eladha_en.db00c6ab.jpg";